import styled from 'styled-components';
import { maxWidth } from 'config/constants';

export const StyledReviewSubmit = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props): string => props.theme.kcc.spacing.LG};
  height: 100%;
  max-width: ${(props): number => props.theme.kcc.screen.CONTENT_MAX_WIDTH}px;

  .review-submit__no-serial-alert {
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    padding: ${(props): string => props.theme.kcc.spacing.SM} ${(props): string => props.theme.kcc.spacing.MD};
    border: none;
  }

  .review-submit__no-serial-alert-icon {
    svg {
      width: 24px;
      height: 24px;
    }
  }

  .review-submit__device-info-label {
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    margin-bottom: 0;
  }

  .review-submit__device-info {
    margin-bottom: 0;
  }

  .review-submit__device-image-wrapper {
    align-self: flex-start;
    max-width: min(225px, 100%);
    max-height: 225px;
    margin-top: ${(props): string => props.theme.kcc.spacing.XS};
    line-height: 0;
  }

  .review-submit__device-image {
    display: block;
    max-width: 100%;
    max-height: 225px;
    height: auto;
  }

  .review-submit__photos {
    margin-top: ${(props): string => props.theme.kcc.spacing.XS};
    display: flex;
    flex-wrap: wrap;
    gap: ${(props): string => props.theme.kcc.spacing.BASE};
  }

  .review-submit__issue-photo-wrapper {
    max-width: min(225px, 100%);
    max-height: 225px;
    flex: 0 1 auto;
    line-height: 0;
  }

  .review-submit__issue-photo {
    display: block;
    max-width: 100%;
    max-height: 225px;
    height: auto;
  }

  .review-submit__cards {
    max-width: 759px;
  }

  .review-submit__title {
    margin-bottom: 0;
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.HEADING_3}px;
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
  }

  .review-submit__issue-description {
    margin-bottom: 0;
    word-break: break-word;
    overflow-wrap: break-word;
  }

  .review-submit__contact-divider {
    border-block-start: 2px solid ${(props): string => props.theme.kcc.colors.BORDER};
    margin: ${(props): string => props.theme.kcc.spacing.BASE} 0;
  }

  .review-submit__submit-btn {
    display: flex;
    margin-left: auto;

    ${maxWidth.m} {
      margin: 0;
      width: fit-content;
    }
  }

  .review-submit__submit-btn-icon {
    display: flex;

    svg {
      width: 20px;
      height: 20px;
    }
  }

  .review-submit__back-btn {
    padding: 0;
    ${maxWidth.m} {
      width: 100%;
      max-width: 172px;
    }
  }

  .review-submit__back-btn-icon {
    .svg-icon {
      display: flex;
    }

    svg {
      width: 20px;
      height: 20px;
    }
  }

  .review-submit__data-protection-link {
    color: ${(props): string => props.theme.kcc.colors.TEXT};
    text-decoration: underline;

    &:hover {
      color: ${(props): string => props.theme.kcc.colors.TEXT};
    }
  }

  .review-submit__checkbox {
    .ant-checkbox {
      align-self: flex-start;
    }
  }

  .review-submit__actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    ${maxWidth.m} {
      gap: ${(props): string => props.theme.kcc.spacing.LG};
    }
  }
`;
